<template>
  <div>
    <p class="mb-2 text-base md:mb-3">
      {{ $t("sidebar.countryText") }}
    </p>

    <p class="block mb-1 font-bold"> {{ $t("sidebar.countryTextLabel") }}</p>
    <div class="flex flex-wrap items-center w-full space-x-3">
      <div class="w-18">
        <validation-provider mode="eager" rules="length:4" v-slot="{ errors }">
          <input
            v-tooltip="tooltipHSN"
            class="block w-full form-input"
            placeholder="HSN"
            v-model="hsn"
            type="text"
          />
          <span class="absolute block px-1 mt-1 text-xs text-red-100 bg-red-500 rounded-sm shadow-lg">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div class="w-16">
        <validation-provider mode="eager" rules="length:3" v-slot="{ errors }">
          <input
            v-tooltip="tooltipTSN"
            class="block w-full form-input"
            placeholder="TSN"
            v-model="tsn"
            type="text"
          />
          <span class="absolute block px-1 mt-1 text-xs text-red-100 bg-red-500 rounded-sm shadow-md">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <base-button
        class="w-auto"
        :loading="isLoading"
        :disabled="!hsn || !tsn"
        @click="handleSubmit(hsn, tsn)"
      >
        {{ $t("sidebar.search") }}
      </base-button>
    </div>
    <transition name="fade">
      <div
        v-if="notFound"
        class="px-3 py-3 mt-4 text-teal-900 bg-gray-200 border-t-4 rounded-sm border-lightblue"
        role="alert"
      >
        <div class="flex">
          <div class="py-1">
            <svg
              class="w-5 h-5 mr-3 fill-current text-lightblue"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"
              />
            </svg>
          </div>
          <div>
            <p class="font-bold">Kein Fahrzeug gefunden</p>
            <p class="text-sm leading-tight">
              Es wurde leider kein Fahrzeug zu den von Ihnen eingegebenen Daten gefunden. Bitte korrigieren Sie Ihre Eingaben oder versuchen Sie die manuelle Suche.
            </p>
          </div>
        </div>
      </div>
    </transition>
    <base-select
      v-if="Array.isArray(this.kba.types) && kba.types.length > 1 && hsn && tsn && !notFound"
      placeholder="Wählen Sie einen Typ"
      label="Typ"
      :options="kba.types"
      @selected="setData"
      target="kba"
    ></base-select>
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';
import BaseSelect from '@/components/BaseSelect.vue';
import { ValidationProvider, extend } from 'vee-validate';
import { length } from 'vee-validate/dist/rules';
import { mapActions, mapState, mapMutations } from 'vuex';
import { updateUrlParams } from '@/util/url-params';

extend('length', {
  ...length,
  message: 'Muss {length}-stellig sein.'
});

export default {
  data: () => ({
    hsn: process.env.NODE_ENV === 'development' ? '8566' : '',
    tsn: process.env.NODE_ENV === 'development' ? 'bff' : '',
    isLoading: false
  }),
  components: {
    BaseSelect,
    BaseButton,
    ValidationProvider
  },
  computed: {
    ...mapState({
      kba: state => state.apiData.kba,
      notFound: state => state.apiData.kba.notFound
    }),
    tooltipHSN () {
      return `<strong>Herstellernummer</strong>: Bitte geben Sie die HSN des PKW ein.<br>Sie muss 4-stellig sein. <img class="py-1" src="${require('@/assets/img/kba.png')}" />`;
    },
    tooltipTSN () {
      return `<strong>Typschlüsselnummer:</strong> Bitte geben Sie die TSN des PKW ein.<br>Sie muss 3-stellig sein. <img class="py-1" src="${require('@/assets/img/kba.png')}" />`;
    }
  },
  methods: {
    ...mapActions(['GET_TYPES_BY_KBA', 'GET_RESULTS', 'UNSET_SELECTED']),
    ...mapMutations(['SET_TYPES_BY_KBA', 'SET_SELECTED']),
    async setData (prop) {
      await this.UNSET_SELECTED({
        selected: ['vehicle', 'make', 'model', 'type'],
        data: ['makers', 'models', 'types', 'results']
      });
      await this.GET_RESULTS(prop.value);
    },
    async handleSubmit (hsn, tsn) {
      this.isLoading = true;
      this.SET_TYPES_BY_KBA([]);
      await this.UNSET_SELECTED({
        selected: ['vehicle', 'make', 'model', 'type'],
        data: ['makers', 'models', 'types', 'results']
      });
      try {
        await this.GET_TYPES_BY_KBA({ hsn: hsn, tsn: tsn });
        if (!this.notFound) {
          if (!Array.isArray(this.kba.types)) {
            updateUrlParams('selectedType', this.kba.types);
          } else {
            updateUrlParams('selectedType', this.kba.types[0].value);
          }
        }
      } catch (err) {
        console.error(err);
      }
      this.isLoading = false;
    }
  }
};
</script>

<style lang="postcss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: all .3s;
}
.fade-enter, .fade-leave-to  {
  opacity: 0;
  transform: translateY(-5px);
}
</style>
